"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../Button"));

var _Spinner = _interopRequireDefault(require("../Spinner"));

var _refresh = _interopRequireDefault(require("../icons/refresh.svg"));

var _config = require("../config/config");

var RefreshButton = function RefreshButton(_ref) {
  var isRefreshing = _ref.isRefreshing,
      Icon = _ref.Icon,
      children = _ref.children,
      disabled = _ref.disabled,
      props = (0, _objectWithoutProperties2.default)(_ref, ["isRefreshing", "Icon", "children", "disabled"]);
  return _react.default.createElement(_Button.default, (0, _extends2.default)({
    Icon: isRefreshing ? _Spinner.default : Icon,
    disabled: isRefreshing || disabled
  }, props), children || (0, _config.__)('Refresh'));
};

RefreshButton.propTypes = process.env.NODE_ENV !== "production" ? {
  disabled: _propTypes.default.bool,
  Icon: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),
  isRefreshing: _propTypes.default.bool
} : {};
RefreshButton.defaultProps = {
  Icon: _refresh.default
};
var _default = RefreshButton;
exports.default = _default;